import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Tenure({ member }) {
  return (

    <ValueItem
      icon="tenure-icon"
      label="Tenure"
    >
      {member.career_histories.find((item) => item.code === 'CUSTOM_CH_Q1')?.answer}
    </ValueItem>
  );
}

Tenure.propTypes = {
  member: PropTypes.object.isRequired,
};
